import { render, staticRenderFns } from "./VueMultiselect.global.vue?vue&type=template&id=056820cc&lang=pug&"
import script from "./VueMultiselect.global.vue?vue&type=script&lang=ts&"
export * from "./VueMultiselect.global.vue?vue&type=script&lang=ts&"
import style0 from "./VueMultiselect.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports